export default "__VITE_ASSET__CxMHsitK__"